import script from "./word.vue?vue&type=script&setup=true&lang=js"
export * from "./word.vue?vue&type=script&setup=true&lang=js"

import "./word.vue?vue&type=style&index=0&id=1215dff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1215dff4"]])

export default __exports__